module.exports = __webpack_public_path__ + "static/img/kudos-logo.af4bea8b.svg";